<button type="button"
        [className]="'btn btn-success'"
        ngbTooltip="{{'submission.workflow.tasks.claimed.approve_help' | translate}}"
        [disabled]="processing$ | async"
        (click)="submitTask()">
  <span *ngIf="processing$ | async"><span aria-hidden="true" class='fas fa-circle-notch fa-spin'></span> {{'submission.workflow.tasks.generic.processing' | translate}}</span>
  <span *ngIf="!(processing$ | async)"><span aria-hidden="true" class="fa fa-thumbs-up"></span> {{'submission.workflow.tasks.claimed.approve' | translate}}</span>
</button>
